import type { GammaPetitionDetailsDataQuery } from '../api.graphql';

type Petition = NonNullable<GammaPetitionDetailsDataQuery['petition']>;
export function getPetitionShareVisuals(petition: Petition) {
	if (!petition.shareVisuals) return [];
	if (petition.shareVisuals.__typename !== 'ShareVisualsConnection') return [];
	return petition.shareVisuals.nodes;
}
